
  import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

  import CellBox from '../../node_modules/vux/src/components/cell-box/index'

export default {
    components: {
      CellBox,
      XHeader,
      Flexbox,
      FlexboxItem
    },
    data () {
      return {
        pageTitle: '',
        userName: false,
        itemId: '',
        article: {
          title: '',
          staffName: '',
          readTimes: 0,
          jian: '',
          context: '',
          fileName: ''
        },
        imageSrc: this.$store.state.url,
        image: '',
        wxFilePath: '', // 附件地址
        baseUrl: this.$store.state.url
      }
    },
    mounted () {
      this.itemId = this.$route.query.id.id
      if (this.itemId == undefined) {
        this.itemId = window.localStorage.getItem('articleId')
      }
      if (this.$store.state.userInfo.accounts) {
        this.userName = this.$store.state.userInfo.accounts
      }
      // 获取新闻详情
      this.axios({
        url: this.$store.state.url + '/wechat/information/viewInformation/' + this.itemId,
        method: 'get'
      }).then((response) => {
        this.article = response.data.obj
        this.image = response.data.photoPath
        this.imageSrc = this.imageSrc + '/' + response.data.photoPath
      }).catch((response) => {

      })
  },
    methods: {
      goLogin () {
        this.$router.push({ name: 'Login'})
      },
      // 获取附件地址
      getFilePath () {
        this.$vux.loading.show({
          text: '加载中'
        })
        window.localStorage.setItem('articleId', this.itemId)
        this.axios({
          url: this.$store.state.url + '/wechat/information/viewFile/' + this.article.id,
          method: 'get'
        }).then((response) => {
          this.$vux.loading.hide()
          this.wxFilePath = response.data.wxFilePath
          this.$router.push({
            path: '/seefile',
            query: {
              loadFile: this.baseUrl + '/' + this.wxFilePath,
              fileName: this.article.fileName
            }
          })
        }).catch((response) => {

        })
      }
    }
  }



// WEBPACK FOOTER //
// ./src/page/Content.vue